/* Gummy Gardens — purchase-journey events (2026-09-23).
   Read-only: watches the product page selections and publishes Shopify customer events that the
   "gg-journey" custom pixel (Settings > Customer events) forwards to GA4 (G-NEGDMP8QGD).
   Never writes inside the Recharge widget; only reads the light DOM, the selling_plan field and the
   widget's shadow tree. Standard ecommerce events (view_item, add_to_cart, checkout, purchase) stay with
   the Google & YouTube app so nothing is double-counted.
   2026-10-12 (founder: human-only engagement): gg_product_state (GA4 'view_product_options') no longer fires on
   page load. It fires once per page view, only after a real interaction with the product form (pointerdown,
   touchstart or keydown on the selectors / buy area, or a flavor, pack or purchase-type change), only when the
   page is visible, and never for automation (navigator.webdriver, headless or crawler user agents). */
(function () {
  if (location.pathname.indexOf('/products/') === -1) return;
  var analytics = window.Shopify && window.Shopify.analytics;
  if (!analytics || typeof analytics.publish !== 'function') return;

  function slug(text) {
    if (!text) return null;
    var t = text.toLowerCase();
    if (t.indexOf('sugar free') > -1 || t.indexOf('tropical') > -1) return 'tropical';
    if (t.indexOf('mixed berry') > -1) return 'mixed_berry';
    if (t.indexOf('mandarin') > -1) return 'mandarin_orange';
    if (t.indexOf('cherry apple') > -1) return 'cherry_apple';
    if (t.indexOf('pineapple') > -1) return 'pineapple';
    return null;
  }

  function productLine() { return location.pathname.indexOf('sugar-free') > -1 ? 'sugar_free' : 'low_sugar'; }

  function flavor() {
    if (productLine() === 'sugar_free') return 'tropical';
    var fs = document.querySelectorAll('variant-selects fieldset, variant-radios fieldset, .product-form__input');
    for (var i = 0; i < fs.length; i++) {
      var legend = fs[i].querySelector('legend, .form__label, label');
      if (!legend || !/flavou?r/i.test(legend.textContent)) continue;
      var c = fs[i].querySelector('input[type="radio"]:checked');
      if (c) return slug(c.value);
      var s = fs[i].querySelector('select');
      if (s) return slug(s.value);
    }
    return null;
  }

  function pack() {
    var c = document.querySelector('.product-form__input input[type="radio"]:checked[value$="PK"]');
    return c ? c.value : null;
  }

  function variantId() {
    var el = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return el ? el.value : null;
  }

  /* Walk the Recharge widget's shadow tree (read-only) for the purchase option and frequency label. */
  function recharge() {
    var host = document.querySelector('recharge-subscription-widget');
    var out = { option: null, frequency: null };
    var plan = document.querySelector('form[action*="/cart/add"] input[name="selling_plan"]');
    if (plan) out.option = plan.value ? 'subscribe' : 'one_time';
    if (!host || !host.shadowRoot) return out;
    var stack = [host.shadowRoot], guard = 0;
    while (stack.length && guard++ < 200) {
      var node = stack.shift(), els;
      try { els = node.querySelectorAll('*'); } catch (e) { continue; }
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (!out.option && el.classList && el.classList.contains('rc-purchase-option__subscription')) {
          var r = el.querySelector('input[type="radio"]');
          if (r) out.option = r.checked ? 'subscribe' : 'one_time';
        }
        if (!out.frequency && el.tagName === 'SELECT' && /week|month|day/i.test(el.textContent || '')) {
          var o = el.options && el.options[el.selectedIndex];
          if (o) out.frequency = o.textContent.trim();
        }
        if (el.shadowRoot) stack.push(el.shadowRoot);
      }
    }
    return out;
  }

  function state() {
    var rc = recharge();
    return {
      product_line: productLine(),
      flavor: flavor(),
      pack_size: pack(),
      purchase_option: rc.option,
      delivery_frequency: rc.option === 'subscribe' ? rc.frequency : null,
      variant_id: variantId(),
      page_path: location.pathname
    };
  }

  var last = null, engaged = false;
  function publish(name, s) { try { analytics.publish(name, s); } catch (e) {} }

  function automated() {
    var ua = navigator.userAgent || '';
    return navigator.webdriver === true ||
      /HeadlessChrome|PhantomJS|Puppeteer|Playwright|Lighthouse|Chrome-Lighthouse|bot\b|bot\/|crawl|spider|slurp|facebookexternalhit|Pinterestbot|AdsBot|Mediapartners|preview|BingPreview|Google-InspectionTool/i.test(ua);
  }

  /* The product form area: selectors, purchase options (the Recharge host element, read via event retargeting
     only), the buy button and the sticky bar. */
  var FORM_AREA = 'product-info, .product__info-container, variant-selects, variant-radios, product-form, ' +
    'form[action*="/cart/add"], recharge-subscription-widget, .gg-sticky-atc';
  function inFormArea(e) {
    var path = e.composedPath ? e.composedPath() : [e.target];
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (el && el.nodeType === 1 && el.matches && el.matches(FORM_AREA)) return true;
    }
    return false;
  }

  /* One view_product_options per page view, after a human touches the product form. */
  function engage() {
    if (engaged || automated() || document.visibilityState !== 'visible') return;
    engaged = true;
    var s = state();
    s.engaged = 1;
    publish('gg_product_state', s);
  }
  function onHuman(e) {
    if (engaged || e.isTrusted === false || !inFormArea(e)) return;
    setTimeout(engage, 400); // let the selection settle so the event carries the chosen flavor/pack
  }

  /* Baseline is recorded silently on load; flavor/pack changes afterwards are human choices. */
  function check() {
    if (automated()) return;
    var s = state();
    if (!last) { last = s; return; }
    var changed = false;
    if (s.flavor && s.flavor !== last.flavor) { publish('gg_select_flavor', s); changed = true; }
    if (s.pack_size && s.pack_size !== last.pack_size) { publish('gg_select_pack', s); changed = true; }
    if (s.purchase_option && last.purchase_option && s.purchase_option !== last.purchase_option) changed = true;
    last = s;
    if (changed && humanSeen) engage();
  }
  var humanSeen = false;

  /* Add-to-cart intent carries the full selection, so GA4 can join choices to the cart step. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (automated()) return;
    if (f && f.action && f.action.indexOf('/cart/add') > -1) { engage(); publish('gg_add_to_cart_selection', state()); }
  }, true);

  var timer = null;
  function start() {
    setTimeout(check, 1500);
    ['pointerdown', 'touchstart', 'keydown'].forEach(function (t) {
      document.addEventListener(t, function (e) { if (e.isTrusted !== false) humanSeen = true; onHuman(e); }, { capture: true, passive: true });
    });
    ['change', 'click'].forEach(function (t) {
      document.addEventListener(t, function (e) {
        if (t === 'change' && e.isTrusted !== false && inFormArea(e)) { humanSeen = true; setTimeout(engage, 400); }
        setTimeout(check, 900);
      }, true);
    });
    if (!timer) timer = setInterval(check, 1200);
    setTimeout(function () { clearInterval(timer); }, 10 * 60 * 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
